import React from 'react';

function Listing() {
	return (
		<div></div>
	);
}

export default Listing;